import { Injectable } from '@angular/core';
import { Subject, Observable, throwError } from 'rxjs';
import { catchError, map, takeUntil } from 'rxjs/operators';
import { RestServiceAbstract } from '../../abstracts/rest-service.abstract';
import { Response } from '../../models/response.model';

@Injectable({
    providedIn: 'root',
})
export class DcEmailRestService extends RestServiceAbstract {
    protected ngUnsubscribe$: Subject<void> = new Subject<void>();

    public getAllowedDc(): Observable<Response> {
        const url = '/usermanagement/admin/dc/emails';
        return this.get(url).pipe(
            takeUntil(this.ngUnsubscribe$),
            map(data => new Response(data)),
            catchError(err => throwError(() => new Error(err)))
        );
    }

    public getEmails(dc: string): Observable<Response> {
        const url = `/usermanagement/admin/dc/emails/${dc}`;
        return this.get(url).pipe(
            takeUntil(this.ngUnsubscribe$),
            map(data => new Response(data)),
            catchError(err => throwError(() => new Error(err)))
        );
    }

    public addEmail(dc: string, emailData: any): Observable<Response> {
        const url = `/usermanagement/admin/dc/emails/${dc}`;
        return this.post(url, emailData).pipe(
            takeUntil(this.ngUnsubscribe$),
            map(data => new Response(data)),
            catchError(err => throwError(() => new Error(err)))
        );
    }

    public deleteEmail(dc: string, id: string): Observable<Response> {
        const url = `/usermanagement/admin/dc/emails/${dc}/${id}`;
        return this.delete(url).pipe(
            takeUntil(this.ngUnsubscribe$),
            map(data => new Response(data)),
            catchError(err => throwError(() => new Error(err)))
        );
    }
}
